import { z } from 'zod';
import { emailValidator, phoneValidator } from '../../validators';
import { addressFields, addressRefinements } from './../../address/address.schema';

const cardholderSchema = z
  .object({
    id: z.number().optional(),
    customerId: z.number().optional(),
    cardType: z.union([z.literal('primary'), z.literal('secondary')]),
    primaryCard: z.union([z.literal('yes'), z.literal('no')]),
    name: z.string().min(1, { message: 'Invalid name on card' }),
    firstName: z.string().min(1, { message: 'Invalid name' }),
    lastName: z.string().min(1, { message: 'Invalid name' }),
    email: z
      .string()
      .refine((value) => {
        return {
          pass: emailValidator(value),
          message: 'Invalid email',
        };
      })
      .optional(),
    phoneNumber: z
      .string()
      .refine((value) => {
        return {
          pass: phoneValidator(value),
          message: 'Invalid phone number',
        };
      })
      .optional(),
  })
  .merge(addressFields);

export function createPrimaryCardholderSchema(metadata: { isAutorenewMembership: boolean }) {
  const primaryCardholderSchema = cardholderSchema.superRefine((cardholder, ctx) => {
    if (metadata.isAutorenewMembership && !cardholder.email) {
      ctx.addIssue({
        code: 'custom',
        path: ['email'],
      });
    }

    addressRefinements(cardholder, ctx);
  });

  return primaryCardholderSchema;
}

export type PrimaryCardholder = z.infer<ReturnType<typeof createPrimaryCardholderSchema>>;
